import { useAnalytics } from '~~/app/composables/useAnalytics'
import { isCartRecoverPath } from '~~/shared/utils/cartRecover'

/**
 * page_view na warstwie danych przy każdej nawigacji SPA (hydracja + router.afterEach).
 *
 * GA4 dostaje odsłony przez wbudowany trigger History Change w kontenerze GTM;
 * ten push dokłada JAWNY obiekt `page` (path/title/type) czytelny dla Segmentify
 * (integracja dataLayer), którego SDK po pierwszym załadowaniu sam nie wykrywa
 * nawigacji SPA. Kontrakt zdarzenia trzyma useAnalytics.trackPageView.
 *
 * Uwaga dla GTM: nie podpinaj tagu GA4 pod event `page_view`, jeśli masz już
 * trigger History Change — inaczej podwójne liczenie odsłon.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const { trackPageView, republishIdentity } = useAnalytics()
  const router = useRouter()
  let lastPath = ''

  function push(route: { fullPath?: string, path?: string, name?: unknown }) {
    // Adres /cart-recover niesie token koszyka z maila — router zna go nadal, choć
    // strona zdjęła go już z paska adresu. Odsłonę liczymy dopiero na /cart.
    if (isCartRecoverPath(route.path ?? '')) return
    const path = route.fullPath || route.path || ''
    if (!path || path === lastPath) return
    lastPath = path
    // Tożsamość PRZED odsłoną — partner czytający warstwę danych ma usera już
    // w chwili rozpoznania strony (zob. useAnalytics.republishIdentity).
    republishIdentity()
    // Kategoria strony dla partnerów czytających dataLayer — kontrakt w utilu.
    trackPageView({ path, type: dataLayerPageType(String(route.name || '')) })
  }

  // Pierwsze wejście — po hydracji SSR router.afterEach nie odpala się dla trasy startowej.
  nuxtApp.hook('app:mounted', () => push(router.currentRoute.value))
  // Kolejne nawigacje SPA.
  router.afterEach(to => push(to))
})
